import React from "react";
import type { SelectChangeEvent } from "@mui/material/Select";
import DSMenuItem from "../../../system-design/DSMenuItem";
import DSSelect from "../../../system-design/DSSelect";

export enum GreetingTone {
  CUTE = "Cute",
  EDGY = "Edgy",
  FUNNY = "Funny",
  INSPIRATIONAL = "Inspirational",
  RELIGIOUS = "Religious",
  ROMANTIC = "Romantic",
  SHORT_SIMPLE = "Short & Simple",
  THOUGHTFUL_NICE = "Thoughtful & Nice",
}

interface ToneSelectorProps {
  value: GreetingTone | null;
  onChange: (tone: GreetingTone | null) => void;
}

const ToneSelector: React.FC<ToneSelectorProps> = ({ value, onChange }) => {
  return (
    <DSSelect
      fullWidth
      value={value ?? ""}
      onChange={(e: SelectChangeEvent<unknown>) => {
        const val = e.target.value as string;
        onChange(val ? (val as GreetingTone) : null);
      }}
      displayEmpty
      sx={{ mt: 1 }}
    >
      <DSMenuItem value="">
        <em>Select a tone (optional)</em>
      </DSMenuItem>
      {Object.values(GreetingTone)
        .filter((tone) => tone !== null)
        .map((tone) => (
          <DSMenuItem key={tone} value={tone}>
            {tone}
          </DSMenuItem>
        ))}
    </DSSelect>
  );
};

export default ToneSelector;
